import React, { FC, useEffect, useState } from "react";
import "./uploadLogo.scss";
import { Upload, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import uploadIcon from "../../../assets/icons/upload.svg";

interface UploadLogoProps {
  logoUrl?: string;
  setFile: Function;
  uploadText?: string;
}

const UploadLogo: FC<UploadLogoProps> = (props) => {
  const { logoUrl, setFile, uploadText } = props;

  useEffect(() => {
    setImageUrl(logoUrl);
  }, [logoUrl]);

  const [loading, setLoading] = useState<boolean>(false);
  const [imageUrl, setImageUrl] = useState<string>();

  const getBase64 = (img: File, callback: Function) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleChange = (info: any) => {
    setLoading(true);
    setTimeout(() => {
      getBase64(info.file.originFileObj, (imageUrl: string) => {
        setLoading(false);
        setFile("displayPicture", info.file.originFileObj);
        setImageUrl(imageUrl);
      });
    }, 250);
  };

  const beforeUpload = (file: File) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!").then();
      return Upload.LIST_IGNORE;
    }
    return isJpgOrPng;
  };

  const uploadButton = (
    <div className="upload-button">
      {loading ? <LoadingOutlined /> : <img src={uploadIcon} alt="" />}
      <div className="upload-button__text">{uploadText || "Upload logo"}</div>
    </div>
  );

  return (
    <Upload
      name="avatar"
      listType="picture-card"
      className="logo-uploader"
      showUploadList={false}
      beforeUpload={beforeUpload}
      onChange={handleChange}
      multiple={false}
    >
      {imageUrl ? (
        <img src={imageUrl} alt="avatar" className="logo-image" />
      ) : (
        uploadButton
      )}
    </Upload>
  );
};

export default UploadLogo;
